// @mui
import { Theme, SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import { useState } from 'react';
import { Typography } from '@mui/material';

// ----------------------------------------------------------------------

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  clip: 'rect(0 0 0 0)',
} as const;

// ----------------------------------------------------------------------

type Props = {
  order?: 'asc' | 'desc';
  orderBy?: string;
  headLabel: any[];
  rowCount?: number;
  numSelected?: number;
  onSort?: (id: string) => void;
  onSelectAllRows?: (checked: boolean) => void;
  sx?: SxProps<Theme>;
  tableOffset?: number;
};

export default function TableHeadCustom({
  order,
  orderBy,
  rowCount = 0,
  headLabel,
  numSelected = 0,
  onSort,
  onSelectAllRows,
  sx,
  tableOffset,
}: Props) {
  const [checked, setChecked] = useState<boolean[]>([false]);

  return (
    <TableHead
      sx={{
        '& .MuiTableCell-head': {
          color: '#A1A5B7',
          backgroundColor: 'inherit',
        },
        ...sx,
      }}
    >
      <TableRow>
        {onSelectAllRows && (
          <TableCell padding="checkbox">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Checkbox
                indeterminate={!!numSelected && numSelected < rowCount}
                // checked={!!rowCount && numSelected === rowCount}
                checked={checked[tableOffset!]}
                onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                  setChecked((prev) => {
                    const updated = [...prev];
                    updated[tableOffset!] = !!checked; // update only this index
                    return updated;
                  });
                  onSelectAllRows(checked);
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontWeight: numSelected > 0 ? 'bold' : 'normal',
                  color: numSelected > 0 ? 'primary.main' : 'text.secondary',
                }}
              >
                {numSelected > 0 ? `${numSelected} items selected` : 'No item selected'}
              </Typography>
            </Box>
          </TableCell>
        )}

        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align || 'center'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ width: headCell.width, minWidth: headCell.minWidth }}
          >
            {onSort ? (
              <TableSortLabel
                hideSortIcon
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={() => onSort(headCell.id)}
              >
                {headCell.label}

                {orderBy === headCell.id ? (
                  <Box sx={{ ...visuallyHidden }}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
